<template>
    <div class="ui-body">
        <!-- 01.主体容器 - 头部 Start -->
        <div class="ui-container-header">
            <!-- 01.01.主体容器 - 头部 - 标题 Start -->
            <h3 class="ui-container-header-title"><i class="ion-ios-arrow-forward"></i>{{ this.$route.meta.title }}</h3>
            <!-- 01.01.主体容器 - 头部 - 标题 End -->
            <!-- 01.02.主体容器 - 头部 - 副标题 Start -->
            <p class="ui-container-header-subtitle">{{ this.$route.meta.description }}</p>
            <!-- 01.02.主体容器 - 头部 - 副标题 End -->
        </div>
        <!-- 01.主体容器 - 头部 End -->

        <!-- 02.主体容器 - 内容 Start -->
        <div class="ui-container-content">
            <div class="ui-content">
                <!-- 02.03.主体容器 - 内容 - 普通面板 Start -->
                <el-form class="ui-container-form" ref="formContent" :model="formContent" :label-width="formWidth" :label-position="formPosition" :rules="formRules">
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <div class="ui-form-panel">
                                <el-scrollbar>
                                    <h4>基础信息</h4>
                                    <el-row :gutter="20">
                                        <el-col :span="8">
                                            <el-form-item label="用户姓名" prop="title">
                                                <el-input v-model="formContent.title"
                                                          placeholder="请选择用户姓名"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8" :offset="8">
                                            <el-upload class="ui-avatar"
                                                       :action="this.$api_url+'/api/upload/images/'"
                                                       :headers="{'token':token}" :show-file-list="false"
                                                       :on-success="handleAvatarSuccess"
                                                       :before-upload="beforeAvatarUpload">
                                                <img v-if="avatarUpload" :src="avatarUpload" class="avatar_images">
                                                <el-empty description="请选择头像" v-else></el-empty>
                                            </el-upload>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="20">
                                        <el-col :span="8">
                                            <el-form-item label="用户名" prop="user_name">
                                                <el-input v-model="formContent.user_name"
                                                          placeholder="请选择用户名"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="20">
                                        <el-col :span="8">
                                            <el-form-item label="密码" prop="pass_word">
                                                <el-input v-model="formContent.pass_word" placeholder="请选择密码"
                                                          show-password :disabled="htmlInput"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="确认密码" prop="pass_word_confirm">
                                                <el-input v-model="formContent.pass_word_confirm"
                                                          placeholder="请选择确认密码" show-password
                                                          :disabled="htmlInput"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="20">
                                        <el-col :span="8">
                                            <el-form-item label="联系电话" prop="phone">
                                                <el-input v-model="formContent.phone"
                                                          placeholder="请选择联系电话"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="电子邮箱" prop="mail">
                                                <el-input v-model="formContent.mail"
                                                          placeholder="请选择电子邮箱"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="20">
                                        <el-col :span="24">
                                            <el-form-item label="权限说明" prop="content">
                                                <quill-editor :options="this.$editor" v-model="formContent.content"
                                                              style="height: 115px"/>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-scrollbar>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
                <!-- 02.03.主体容器 - 内容 - 普通面板 End -->
            </div>
        </div>
        <!-- 02.主体容器 - 内容 End -->

        <!-- 03.主体容器 - 尾部 Start -->
        <div class="ui-container-footer ">
            <!-- 03.01.主体容器 - 尾部 - 按钮 Start -->
            <div class="ui-container-footer-group" v-if="$Permissions(['UserPatch','UserCreate'])">
                <el-button type="primary" @click="formSubmit"><i class="ion-ios-add-circle"></i>{{ htmlSubmit }}
                </el-button>
                <el-button @click="onReset"><i class="ion-ios-refresh-circle"></i>重置</el-button>
            </div>
            <!-- 03.01.主体容器 - 尾部 - 按钮 End -->
        </div>
        <!-- 03.主体容器 - 尾部 End -->
    </div>
</template>

<script>
    export default {
        name: "add_user",
        data() {
            // 这里存放数据
            // 00.自定义密码验证
            var pass_verification = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'))
                } else {
                    callback()
                }
            }
            var pass_confirm_verification = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入确认密码'))
                } else if (value !== this.formContent.pass_word) {
                    callback(new Error('两次输入密码不一致!'))
                } else {
                    callback()
                }
            }

            return {
                // 00.Token
                token: localStorage.getItem('Token'),
                // 01.显示模式 ------------------------------------------------
                // 01.01.Html标题
                htmlTitle: this.$route.meta.title,
                // 01.02.Html描述
                htmlDescription: this.$route.meta.description,
                // 01.03.Html按钮标题
                htmlSubmit: "添加",
                // 01.04.密码input是否启用
                htmlInput: true,
                // 02.Form 配置/数据集 ------------------------------------------------
                // 02.01.Form提交API地址
                formAPI: '/api/create/user/',
                // 02.01.Form配置 - 标题位置
                formPosition: 'top',
                // 02.01.Form配置 - 标题宽度
                formWidth: '130px',
                // 02.02.Form数据集
                formContent: {
                    title: '',
                    user_name: '',
                    pass_word: '',
                    pass_word_confirm: '',
                    phone: '',
                    mail: '',
                    content: '',
                    avatar_upload: ''
                },
                // 02.03.Form 验证
                formRules: {
                    user_name: [
                        {required: true, message: '请输入用户姓名', trigger: 'blur'}
                    ],
                    pass_word: [
                        {required: true, validator: pass_verification, trigger: 'blur'}
                    ],
                    pass_word_confirm: [
                        {required: true, validator: pass_confirm_verification, trigger: 'blur'}
                    ]
                },
                // 03.其他数据集 ------------------------------------------------
                // 03.01.头像默认数据
                avatarUpload: '',
            }
        },
        // 方法集合
        methods: {
            // 01.Form表单提交
            formSubmit() {
                this.$refs['formContent'].validate((valid) => {
                    if (valid) {
                        this.$api.post(this.formAPI, this.formContent).then((response) => {
                            this.$message.success(response)
                        })
                    }
                })
            },
            // 02.重置Form表单
            onReset() {
                this.$refs['formContent'].resetFields()
            },
            // 03.获取Form数据
            getForm() {
                this.$api.get('/api/get/user-data/', {'id': this.$route.params.id}).then((response) => {
                    if (response.data[0].avatar) {
                        this.avatarUpload = this.$api_url + '/static/upload' + response.data[0].avatar
                    }
                    this.formContent.avatar_upload = response.data[0].avatar
                    this.formContent.title = response.data[0].title
                    this.formContent.phone = response.data[0].phone
                    this.formContent.mail = response.data[0].mail
                    this.formContent.user_name = response.data[0].user_name
                    this.formContent.content = response.data[0].content
                })
            },
            // 04.头像上传
            handleAvatarSuccess(res, file) {
                this.formContent.avatar_upload = res.data
                this.avatarUpload = URL.createObjectURL(file.raw)
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type
                const isLt2M = file.size / 1024 / 1024 < 2
                if (isJPG !== 'image/jpeg') {
                    if (isJPG !== 'image/png') {
                        this.$message.error('上传头像图片类型只能是 jpg、png格式')
                    }
                } else {
                    if (!isLt2M) {
                        this.$message.error('上传头像图片大小不能超过 2Mb')
                    }
                }
                return isJPG && isLt2M
            },
        },
        // 生命周期 - 挂载完成
        mounted() {
            // 01.判断当前写入/修改状态
            if (this.$route.params.id) {
                // 01.01.修改状态
                this.htmlInput = true
                this.formRules.pass_word[0].required = false
                this.formRules.pass_word[0].validator = null
                this.formRules.pass_word_confirm[0].required = false
                this.formRules.pass_word_confirm[0].validator = null

                this.formAPI = '/api/patch/user/?id=' + this.$route.params.id
                this.htmlSubmit = "修改"
                this.getForm()
            } else {
                // 01.02.写入状态
                this.htmlInput = false
                this.formAPI = '/api/create/user/'
                this.htmlSubmit = "添加"
            }
        },
    }
</script>
